import { render, staticRenderFns } from "./question_item.vue?vue&type=template&id=5d3e4b8d&scoped=true"
import script from "./question_item.vue?vue&type=script&lang=js"
export * from "./question_item.vue?vue&type=script&lang=js"
import style0 from "./question_item.vue?vue&type=style&index=0&id=5d3e4b8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3e4b8d",
  null
  
)

export default component.exports